import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchRecord, SearchPackage } from '../models/searchPackage';
import { UserLight } from '../models/userLight';
import { Client } from '../models/clientLocation';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ClientService {
  constructor(private http : HttpClient) { 
  }

  GetClientLocations(id : number) : Observable<Object>{
    return this.http.get(environment.baseURl + `/api/client/locations/${id}`)
  }

  FetchClientUsers(id : number) : Observable<Array<UserLight>>{
    return this.http.get<Array<UserLight>>(environment.baseURl + `/api/client/users/` + id);
  }

  FetchClientList() : Observable<Array<Client>>{
    return this.http.get<Array<Client>>(environment.baseURl + `/api/client/cra/clients`);
  }

  FetchClientSearchPackages(id : Number) : Observable<Array<SearchPackage>>{
    return this.http.get<Array<SearchPackage>>(environment.baseURl + `/api/client/packages/` + id);
  }

  GetSearchTypes(): Observable<Object>{
    return this.http.get(environment.baseURl + `/api/search/searches`)
  }

  SaveSearchPackage(pkg: SearchPackage){
    return this.http.post(environment.baseURl + '/api/search/packages', pkg)
  }
}
